import '../stylesheets/app.entry.css'

import 'intersection-observer'

import 'common/service/sentry'
import 'common/lazyload'

import {
  onLCP,
  onFID,
  onCLS,
  onFCP,
  onTTFB,
  onINP
} from 'web-vitals/attribution'

const sendToAnalytic = ({ name, id, delta }: any) => {
  // @ts-ignore
  if (!window.dataLayer) return
  // @ts-ignore
  dataLayer.push({
    event: 'GAEvent',
    event_category: 'Web Vitals',
    event_action: name,
    event_label: id,
    event_value: Math.round(name === 'CLS' ? delta * 1000 : delta)
  })
}
onLCP(sendToAnalytic)
onFID(sendToAnalytic)
onCLS(sendToAnalytic)
onFCP(sendToAnalytic)
onTTFB(sendToAnalytic)
onINP(sendToAnalytic)
